module.exports = __webpack_public_path__ + "img/alpha-c-circle-outline.b380c28.svg";